"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePicker = void 0;
const react_1 = __importDefault(require("react"));
const x_date_pickers_1 = require("@mui/x-date-pickers");
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = __importDefault(require("../Button"));
const hooks_1 = require("../hooks");
const IconWrapper_1 = __importDefault(require("../Icons/IconWrapper"));
const IconSizes_1 = require("../Icons/PropTypes/IconSizes");
const useTranslations_1 = require("../hooks/useTranslations");
const styles_1 = require("./styles");
const hooks_2 = require("./hooks");
const helpers_1 = require("./helpers");
const TimePicker = (props) => {
    let adaptedProps;
    if ((0, helpers_1.isLegacyProps)(props)) {
        adaptedProps = (0, helpers_1.legacyPropsAdapter)(props);
    }
    else {
        adaptedProps = (0, helpers_1.newPropsAdapter)(props);
    }
    const { ref, ampm = false, className, format = "hh:mm", name, open, placeholder, timeSteps = { hours: 1, minutes: 5 }, views = ["hours", "minutes"], onClose, onOpen, openPickerIcon = DefaultOpenPickerIcon, "aria-labelledby": ariaLabelledBy } = adaptedProps, pickerProps = __rest(adaptedProps, ["ref", "ampm", "className", "format", "name", "open", "placeholder", "timeSteps", "views", "onClose", "onOpen", "openPickerIcon", "aria-labelledby"]);
    const { ref: rootRef, getGerudoContainer } = (0, hooks_1.useGetGerudoContainer)();
    const { isOpen, onOpenPopup, onClosePopup } = (0, hooks_2.useOpenState)({ open, onOpen, onClose });
    const classes = (0, classnames_1.default)("gerudo-timepicker", "gerudo-input", className);
    return (react_1.default.createElement("div", { className: classes, ref: rootRef },
        react_1.default.createElement(x_date_pickers_1.TimePicker, Object.assign({}, pickerProps, { inputRef: ref, ampm: ampm, className: classes, format: format, open: isOpen, timeSteps: timeSteps, onClose: onClosePopup, onOpen: onOpenPopup, views: views, 
            // TimePicker's mobile rendering doesn't match our UI Kit at all so just ignore it
            desktopModeMediaQuery: "@media (min-width: 0px)", slots: {
                openPickerIcon: openPickerIcon.bind(null, { open: isOpen }),
                actionBar: ActionBar,
            }, slotProps: {
                textField: { placeholder, name, "aria-labelledby": ariaLabelledBy },
                popper: {
                    sx: styles_1.sxPopper,
                    container: getGerudoContainer,
                },
            } }))));
};
exports.TimePicker = TimePicker;
const ActionBar = ({ className, onAccept }) => {
    const t = (0, useTranslations_1.useGlobalTranslations)();
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Button_1.default, { onClick: onAccept }, t("ok"))));
};
const DefaultOpenPickerIcon = ({ open }) => (react_1.default.createElement(IconWrapper_1.default, { size: IconSizes_1.IconSizes.Medium, name: open ? "ChevronUp" : "ChevronDown" }));
//# sourceMappingURL=TimePicker.js.map